export default "__VITE_PUBLIC_ASSET__a09de5c7__"